<template>
  <div class="content">
    <el-pagination
      background
      @size-change="$emit('sizeChange',$event)"
      @current-change="$emit('currentChange', $event);"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :current-page="page"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>

export default {
  components: {},
  computed: {},
  props: {
    total: {
      type: Number,
    },
    page: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
  },
  data() {
    return {};
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.content{
  display: flex;
  align-items: center;
}
</style>
